var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/wishlist-nav-accordion.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"currentWishlist");
frame.set("currentWishlist", t_1, true);
if(frame.topLevel) {
context.setVariable("currentWishlist", t_1);
}
if(frame.topLevel) {
context.addExport("currentWishlist", t_1);
}
output += "\n\n<a class=\"o-secondary-navigation__a\" href=\"";
output += runtime.suppressValue((lineno = 2, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "wishlistUrl"), "wishlistUrl", context, [])), env.opts.autoescape);
output += "\" data-qa-my-account-nav=\"account_navigation-wishLists\">\n    ";
output += runtime.suppressValue((lineno = 3, colno = 5, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-wishLists",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n</a>\n\n<a href=\"#o-accordion__panel--1\" id=\"o-accordion__tab--1\" class=\"o-accordion__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"o-accordion__panel--1\" aria-expanded=\"true\" role=\"tab\" data-accordion-title=\"";
output += runtime.suppressValue((lineno = 6, colno = 215, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-wishLists",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\">\n    <span class=\"o-accordion__control\" title=\"";
output += runtime.suppressValue((lineno = 7, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["accordion-tooltip_collapse",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\"></span>\n</a>\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")) {
output += "\n    <div id=\"o-accordion__panel--1\" class=\"o-accordion__panel js-accordion-panel\" aria-labelledby=\"o-accordion__tab--1\" aria-hidden=\"false\" role=\"tabpanel\">\n";
;
}
output += "\n\n        <ul class=\"o-secondary-navigation__ul o-secondary-navigation__ul--nested\" itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\">\n\n        ";
frame = frame.push();
var t_4 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"wishlists");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("wishlist", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += "\n            ";
var t_6;
t_6 = ((runtime.memberLookup((t_5),"id") == runtime.contextOrFrameLookup(context, frame, "currentWishlist"))?"o-secondary-navigation__a--current":"");
frame.set("isCurrentClass", t_6, true);
if(frame.topLevel) {
context.setVariable("isCurrentClass", t_6);
}
if(frame.topLevel) {
context.addExport("isCurrentClass", t_6);
}
output += "\n            <li class=\"o-secondary-navigation__li o-secondary-navigation__li--nested ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")?"o-secondary-navigation__li--accordion o-accordion__tabset js-accordion-tabset is-collapsed":""), env.opts.autoescape);
output += "\" role=\"menuitem\">\n                <a class=\"o-secondary-navigation__a o-secondary-navigation__a--nested ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "isCurrentClass"), env.opts.autoescape);
output += " js-secondary-navigation__a\" href=\"";
output += runtime.suppressValue((lineno = 19, colno = 149, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "wishlistUrl"), "wishlistUrl", context, [runtime.memberLookup((t_5),"id")])), env.opts.autoescape);
output += "\" data-qa-wishlist-secondary-nav-item=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\n                </a>\n            </li>\n\n        ";
;
}
}
frame = frame.pop();
output += "\n\n    </ul>\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")) {
output += "\n    </div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/wishlist-nav-accordion.j2"] , dependencies)